import { getItem } from "helpers/storage";
import {STORAGE_KEY, CHAIN_ROLE, IMPERSONATIONTOKEN} from "state/auth";

export const getHeaders = (headers: any = {}) => {
  const token = getItem(STORAGE_KEY);
  const impersonationToken = getItem(IMPERSONATIONTOKEN);
  const chainRoleAccess = getItem(CHAIN_ROLE)
  let role;
  if(chainRoleAccess && chainRoleAccess!==undefined){
    role = JSON.parse(chainRoleAccess).role_name
  }else{
    role=''
  }

  const newHeaders = { ...headers };
  if (token) {
    newHeaders["Authorization"] = `Bearer ${token}`;
    newHeaders["ChainRole"] = `${role}`
  }
  if(impersonationToken){
    newHeaders['x-impersonation-token'] = impersonationToken
  }

  return { headers: newHeaders };
};
